/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { InstallmentCalculatorCallToActionFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { InstallmentCalculatorCallToActionFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const installmentCalculatorCallToActionDataMock: InstallmentCalculatorCallToActionFragmentFragment =
  {
    numberOfInstallments: 20,
    singleInstallment: {
      format: 'CURRENCY',
      value: 13.37,
    },
    currency: 'EUR',
  };

export function getInstallmentCalculatorCallToActionFragmentedData(
  data?: InstallmentCalculatorCallToActionFragmentFragment,
) {
  return makeFragmentData(
    data || installmentCalculatorCallToActionDataMock,
    InstallmentCalculatorCallToActionFragmentFragmentDoc,
  );
}
